import { AppRouteRecordRaw } from '@/router/types'

export const financial: AppRouteRecordRaw[] = [
  {
    path: 'financial',
    name: 'financial',
    redirect: '/financial/settlementRecord',
    meta: {
      title: '财务管理'
    },
    children: [
      {
        path: 'settlementRecord',
        name: 'settlementRecord',
        component: () => import('@/views/financial/settlementRecord/index.vue'),
        meta: {
          title: '结算单'
        },
        children: []
      },
      {
        path: 'trade',
        name: 'trade',
        component: () => import('@/views/financial/trade/index.vue'),
        meta: {
          title: '交易记录'
        },
        children: []
      },
      {
        path: 'dataStatistics',
        name: 'dataStatistics',
        component: () => import('@/views/financial/dataStatistics/index.vue'),
        meta: {
          title: '数据统计'
        }
      },
      {
        path: 'accountManage',
        name: 'AccountManage',
        component: () => import('@/views/erp/systemManage/financeManage/accountManage/index.vue'),
        meta: {
          title: '账户管理'
        }
      },
      {
        path: 'receivablesManage',
        name: 'ReceivablesManage',
        component: () =>
          import('@/views/erp/systemManage/financeManage/receivablesManage/index.vue'),
        meta: {
          title: '应收款管理',
          keepAlive: true
        }
      },
      {
        path: 'transferRepayment',
        name: 'TransferRepayment',
        component: () =>
          import('@/views/erp/systemManage/financeManage/transferRepayment/index.vue'),
        meta: {
          title: '转账还款明细',
          keepAlive: true
        }
      }

      // 迁移
      // {
      //   path: 'storeSettlement',
      //   name: 'storeSettlement',
      //   component: () => import('@/views/financial/storeSettlement/index.vue'),
      //   meta: {
      //     title: '门店结算'
      //   },
      //   children: []
      // },

      // {
      //   path: 'userChargeDetail',
      //   name: 'userChargeDetail',
      //   component: () => import('@/views/financial/userChargeDetail/index.vue'),
      //   meta: {
      //     title: '用户费用明细'
      //   },
      //   children: []
      // }
    ]
  },
  {
    path: 'receivablesManageDetail',
    name: 'ReceivablesManageDetail',
    component: () =>
      import('@/views/erp/systemManage/financeManage/receivablesManage/detail/index.vue'),
    meta: {
      title: '应收款管理详情'
    }
  },
  {
    path: 'rjtManageConfig',
    name: 'RjtManageConfig',
    redirect: '/rjtManageConfig/serviceConfiguration',
    meta: {
      title: '融金通管理配置'
    },
    children: [
      {
        path: 'serviceConfiguration',
        name: 'ServiceConfiguration',
        component: () =>
          import(
            '@/views/erp/systemManage/financeManage/rjtManageConfig/serviceConfiguration/index.vue'
          ),
        meta: {
          title: '服务费扣费配置'
        }
      }
    ]
  }
]
